console.log("Claviyo fix added.");
document.addEventListener("click", function (event) {
  const modalBackdrop = document.querySelector(
    'div[role="dialog"].kl-private-reset-css-Xuajs1'
  );

  if (!modalBackdrop) return; // Exit if modal backdrop doesn't exist

  // Handle close button (X)
  if (event.target.closest(".klaviyo-close-form")) {
    modalBackdrop.remove();
    return;
  }

  // Handle "No, Thanks" button click
  if (
    event.target.matches(".klaviyo-form button") &&
    event.target.textContent.trim().toUpperCase() === "NO, THANKS"
  ) {
    modalBackdrop.remove();
    return;
  }

  // Handle clicks outside the modal form content to close the modal
  if (!event.target.closest(".klaviyo-form")) {
    modalBackdrop.remove();
  }
});
